import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { selectors, actions } from '../../../Stream';
import { Props } from './ThreadPagination';

export type StateProps = Pick<Props, 'hasMore' | 'isFetching'>;
export type DispatchProps = Pick<Props, 'onLoadMore'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = (
  state,
  { direction, streamId }
) => {
  return {
    hasMore: selectors.getHasMoreInDirection(state, streamId, direction),
    isFetching: selectors.isFetching(state, streamId),
  };
};
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { streamId, direction }
) => ({
  onLoadMore: () => dispatch(actions.fetch(streamId, direction)),
});

export default connect(mapStateToProps, mapDispatchToProps);
